import { render, staticRenderFns } from "./FinanceWalletsAggregationFilters.vue?vue&type=template&id=0acbcbc4&"
import script from "./FinanceWalletsAggregationFilters.vue?vue&type=script&lang=js&"
export * from "./FinanceWalletsAggregationFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports